// Zentrale Definition der Länder-Mandanten.
// Einzige Quelle für Country-Auswahl (Components/Pages/CountrySelect)
// und Country -> Sprache (Hooks/useCountryLanguage).
//
// Neues Land hinzufügen: hier einen Eintrag ergänzen — sonst nichts.
//   code  — URL-Segment (/ES/pages/home). "" = Default-Mandant ohne Prefix.
//   label — Anzeigename in der Auswahl
//   flag  — flag-icon-Suffix (siehe CSS-Klasse flag-icon-*)
//   lang  — i18n-Resource-Key (siehe src/i18n.jsx)
export const COUNTRIES = [
  { code: '', label: 'Deutschland', flag: 'de', lang: 'du' },
  { code: 'BR', label: 'Brasilien', flag: 'br', lang: 'pt-BR' },
  { code: 'ES', label: 'Spanien', flag: 'es', lang: 'es' },
]

// URL-Country (case-insensitive) -> i18n-Sprache.
// Enthält nur Länder mit code !== "", da der Default-Mandant kein
// URL-Segment hat und dort die Browser-Sprache greift.
export const COUNTRY_TO_LANG = COUNTRIES.reduce((map, { code, lang }) => {
  if (code) map[code.toUpperCase()] = lang
  return map
}, {})

// Sprache für ein URL-Country-Segment, oder undefined wenn unbekannt.
export const languageForCountry = (country) =>
  country ? COUNTRY_TO_LANG[country.toUpperCase()] : undefined

export default COUNTRIES
